<template>
  <div v-loading="loading" class="MainViewPort">
    <canvas id="canvas" />
  </div>
</template>

<script>
import { fabric } from 'fabric'
// import EventHandle from './utils/eventHandler'
import macBg from '@/assets/img/visual/macBg.png'
import debounce from 'lodash/debounce'
import Editor from './core/index.js'
import { convertPoints, findTopLeft, processAndFindBestEdge, isSpecialRectangle } from '@/components/OppleCanvas/canvas/utils/findTopLeft.js'
import { CANVAS_COMPONENT, CANVAS_ZOOM_NUMBER, GROUP_STATUS} from '@/page/visualMap/utils/enums.js'
import eventBus from '@/utils/eventBus'

function throttle(func, delay, options = {}) {
  let lastCallTime = 0;
  let timeoutId = null;
  const { leading = true, trailing = true } = options;
  
  // 返回节流后的函数
  return function(...args) {
    const now = Date.now();
    const context = this;
    
    // 如果leading为false或者还没到时间，重置lastCallTime
    if (!leading && lastCallTime === 0) {
      lastCallTime = now;
    }
    
    const remaining = delay - (now - lastCallTime);
    
    // 清除之前的定时器
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    
    // 如果到达或超过延迟时间，或者remaining为负数(系统时间被调整)
    if (remaining <= 0 || remaining > delay) {
      if (leading) {
        lastCallTime = now;
        func.apply(context, args);
      }
    } else if (trailing && !timeoutId) {
      // 设置定时器，在剩余时间后执行
      timeoutId = setTimeout(() => {
        lastCallTime = leading ? Date.now() : 0;
        func.apply(context, args);
        timeoutId = null;
      }, remaining);
    }
  };
}

// const event = new EventHandle()
/**
 * @type {{c:fabric.Canvas}}
 */
export const canvas = {}

const TOOLS = {
  DRAWRECT: 'rect',
  DRAWPENCIL: 'pencil',
  SELECT: 'select',
  OPACITY: 'opacity',
}

//传感器状态
const SENSORTYPE = {
  HASPERSON: '1',
  HASNOTPERSON: '0',
}

let cc = 0;
let dd = 0;

/**
 * 设备的CILDCATEGORYTYPE
 * @enum {Number} 128 传感器
 */

const DEVICE_CILDCATEGORYTYPE = {
  SENSOR: 128,
}

let downPoint, upPoint
let path, str // path是绘制pencil的对象,str是其路径

export default {
  name: 'VisualHome',
  provide: {
    canvas,
    fabric,
    // event
  },
  inject: {
    /** 是否为地图监控模式 */
    isMonitor: { default: false },
    /** 地图容器选择器 */
    mapContainerSelector: { default: '' },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    initialRoomNameOffsetFun: {
      type: Function,
      default: () => {},
    },
    isEscPressed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      canvas: null,
      dotOffsetX: -260,
      dotOffsetY: -60,
      lastPosX: null,
      lastPosY: null,
      menuPosition: {},
      activeEl: null,
      isDraggMoving: false,
      currentTool: '',
      isDragging: true,
      canvasDeviceData: null,
      pointPosition: [], // 点的位置坐标信息
      pointArray: [], // 点的对象组合
      snappedPoint: null,
      guideline: null, // 初始化对齐辅助线
      initialRoomNamePositions: null,
      enterGroup: null,
      lastTime: 0, //记录上次滚轮事件的时间
      hasMax: 0, // 已经最大最小, 第几次
      loadNum: 0, // 判断是否loadNum
      hasLoadNum: 0, //已经加载了多少loadNum
      firstImgScale: 1, // 第一次图片加载的比例
      img:{}
      // enterGroup:null
    }
  },
  watch: {
    currentTool: function (val) {
      if (val !== TOOLS.DRAWPENCIL) {
        this.removePoint()
        this.canvasData && this.canvasData.remove(path)
      }
    },
  },

  mounted() {
    this.canvas = canvas.c = new fabric.Canvas('canvas', {
      width: this.getWindowSize().width, // 画布宽度
      height: this.getWindowSize().height, // 画布高度
      selectionFullyContained: true, // 框选包裹图形才会被选中
      preserveObjectStacking: true, // 保持当前层级
      selectionColor: 'rgba(0,0,0,0)',
      selectionBorderColor: '#70c0ff',
      fireRightClick: true, // 启用右键，监听mousedown事件button = 3
      stopContextMenu: true, // 禁止默认右键菜单
      selectionKey: 'ctrlKey', // 开启单点选择画布
      selection: true, // 允许全局选择
    })

    // 保存原始方法
    const originalRequestRenderAll = this.canvas.requestRenderAll.bind(this.canvas);

    const originalRenderAll = this.canvas.renderAll.bind(this.canvas);

    // 覆盖当前实例的方法
    this.canvas.requestRenderAll = throttle(function() {
      console.log('绘制 requestRenderAll', ++cc);
      return originalRequestRenderAll.apply(this, arguments);
    }, 150);
    this.canvas.renderAll = throttle(function() {
      console.log('绘制 renderAll', ++dd);
      return originalRenderAll.apply(this, arguments);
    }, 150);

    // event.init(canvas.c)
    canvas.editor = new Editor(canvas.c)
    this.resetCanvasBg()
    this.initWindow()
    this.initMouseFun()

    fabric.Canvas.prototype.getAbsoluteCoords = function (object) {
      return {
        left: object.left + this._offset.left,
        top: object.top + this._offset.top,
      }
    }

    eventBus.$on('updateDeviceName', ({ device, field, value }) => {
      this.changeEquName(device, field, value)
    })
  },
  beforeDestroy() {
    this.removeMouseFun()
    // canvas.c.dispose()
    canvas.editor.canvas.forEachObject(obj => {
      Object.keys(obj).forEach(key => {
        delete obj[key] 
      })
    })
   
    this.canvas.forEachObject(obj => {
      Object.keys(obj).forEach(key => {
        delete obj[key] 
      })

    })
    canvas.c.forEachObject(obj => {
      Object.keys(obj).forEach(key => {
        delete obj[key] 
      })

    })

    delete canvas.c

    window.removeEventListener('resize', this.handleResize)
    console.log('销毁画布')
  },
  methods: {
    resetCanvasBg() {
      /* 初始化平移画布 左边上边距各留10px */
      canvas.c.absolutePan(new fabric.Point(this.dotOffsetX, this.dotOffsetY))
    },
    handleResize: debounce(function () {
      const windowGlobalSize = this.getWindowSize()
      canvas.c.setWidth(windowGlobalSize.width)
      canvas.c.setHeight(windowGlobalSize.height)
      canvas.c.requestRenderAll()
    }, 1000),
    initWindow() {
      // let windowGlobalSize
      // const size = () => {
      //   windowGlobalSize = this.getWindowSize()
      //   canvas.c.setWidth(windowGlobalSize.width)
      //   canvas.c.setHeight(windowGlobalSize.height)
      //   canvas.c.requestRenderAll()
      // }
      // window.addEventListener('resize', () => {
      //   setTimeout(() => {
      //     size()
      //   }, 1000)
      // })
      window.addEventListener('resize', this.handleResize)
    },
    addCircleWithImage(imageUrl, left, top) {
      fabric.Image.fromURL(imageUrl, img => {
        img.scaleToWidth(27)
        img.scaleToHeight(27)
        const circle = new fabric.Circle({
          radius: 39 / 2,
          fill: '#fff',
          stroke: '#48A3FF',
          strokeWidth: 0,
          originX: 'center',
          originY: 'center',
        })

        const group = new fabric.Group([circle, img], {
          left: left,
          top: top,
        })

        group.on('mouseover', () => {
          circle.strokeWidth = 3
          canvas.c.requestRenderAll()
        })
        group.on('mouseout', () => {
          circle.strokeWidth = 0
          canvas.c.requestRenderAll()
        })
        canvas.c.add(group)
      })
    },
    initMouseFun() {
      canvas.c.on('mouse:wheel', opt => {
        if (!this.$store.state.mapGroup) {
          const delta = opt.e.deltaY // 滚轮向上滚一下是 -100，向下滚一下是 100
          let zoom = canvas.c.getZoom() // 获取画布当前缩放值
          const zoomPoint = {
            x: opt.e.offsetX, // 鼠标x轴坐标
            y: opt.e.offsetY, // 鼠标y轴坐标
          }
          // 控制缩放范围在 0.01~20 的区间内
          zoom *= 0.999 ** delta
          if (zoom > 2) zoom = 2
          if (zoom < 0.01) zoom = 0.01

          // 地图监控模式下，最小缩放值为0.3
          if (this.isMonitor && zoom < 0.3) zoom = 0.3

          // canvas.c.setViewportTransform(fabric.iMatrix.concat())
          // 设置画布缩放比例
          // 关键点！！！
          // 参数1：将画布的所放点设置成鼠标当前位置
          // 参数2：传入缩放值
          canvas.c.zoomToPoint(
            zoomPoint,
            zoom // 最后要缩放的值
          )
          return
        }
        try {
          const deltaThreshold = 2 // 滚动的最小阈值，超过此值才触发缩放
          const zoomFactor = CANVAS_ZOOM_NUMBER.INTERVAL // 每次缩放的比例（可以调整，越小越细腻）
          const delta = opt.e.deltaY // 滚轮向上滚一下是 -100，向下滚一下是 100
          const zoom = canvas.c.backgroundImage.scaleX || 1 // 获取画布当前缩放值
          let newZoom = zoom

          // 超过阈值才触发
          if (delta < 0) {
            newZoom += zoomFactor
          } else {
            newZoom -= zoomFactor
          }

          // 记录当前时间
          const now = Date.now()
          // 控制缩放的频率，防止快速触发
          if (now - this.lastTime > 50) {
            const zoomPoint = canvas.c.getPointer(opt)
            // 限制事件触发频率，50ms内只触发一次
            if (Math.abs(delta) > deltaThreshold) {
              // 限制缩放范围
              this.handleMouseWheel(zoom, newZoom, zoomPoint)
              opt.e.preventDefault()
              opt.e.stopPropagation()
            }

            this.lastTime = now // 更新最后触发时间
          }
        } catch (error) {
          console.error('....缩放error', error)
        }
      })

      canvas.c.on('mouse:down', async options => {
        console.log('🚀 ~ canvas.c.on ~ options:', options)
        this.$emit('mouse:down', options)
        downPoint = options.absolutePointer
        const evt = options.e

        /* 右击终止不规则区域 */
        if (options.button === 3) {
          if (this.pointArray.length >= 3) {
            this.finishDrawing(options)
            this.removePoint()
            return
          }
        }

        if (
          this.currentTool === TOOLS.DRAWPENCIL &&
          options.button !== 3 &&
          (options?.target === null || (options?.target?.fill === 'red' && options?.target?.type === 'circle'))
        ) {
          // 如果str包含z,也就是说路径里面有z,说明图形已经绘画完毕了,将之前的所有点和点的位置信息全部清空
          if (str && str.indexOf('z') !== -1) {
            this.removePoint()
            this.canvas.remove(this.tempLine)
            this.tempLine = null

            // 清理状态
            this.canvas.off('mouse:move', this.drawTemporaryPath)
            this.canvas.off('mouse:move', this.drawGuideline)
            // addPoint(e);
          } else if (options.target && this.pointArray[0] && options.target.id === this.pointArray[0].id) {
            // 目标点和第一个点id相等时,说明绘画动作已经完成,此时开始最后一步绘画
            this.finishDrawing(options)
            this.removePoint()
            this.canvas.remove(this.tempLine)
            this.tempLine = null
            // 清理状态
            this.canvas.off('mouse:move', this.drawTemporaryPath)
            this.canvas.off('mouse:move', this.drawGuideline)
          } else {
            if (canvas.c.getActiveObject()) return
            this.addPoint(options)
          }
        }

        if (this.isDragging) {
          canvas.c.selectionBorderColor = 'rgba(0,0,0,0)'
          this.isDraggMoving = true
          if (evt.type === 'mousedown') {
            this.lastPosX = evt.clientX
            this.lastPosY = evt.clientY
          } else if (evt.type === 'touchstart') {
            this.lastPosX = evt.touches[0].clientX
            this.lastPosY = evt.touches[0].clientY
          }
        } else {
          canvas.c.selectionBorderColor = '#70c0ff'
        }
      })
      canvas.c.on('mouse:up', options => {
        this.$emit('mouse:up', options)

        upPoint = options.absolutePointer

        if (this.currentTool === TOOLS.DRAWRECT && options.target === null) {
          this.doDrawRect()
        }
        canvas.c.setViewportTransform(canvas.c.viewportTransform)
        this.isDraggMoving = false
        canvas.c.defaultCursor = 'default'
      })
      canvas.c.on('drop', options => {
        this.$emit('drop', options)
      })

      canvas.c.on('dragenter', options => {
        this.$emit('dragenter', options)
      })
      canvas.c.on('mouse:over', options => {
        this.$emit('mouse:over', options)
      })

      canvas.c.on('mouse:out', options => {
        canvas.c.hoverCursor = 'default'
        canvas.c.moveCursor = 'default'
        this.$emit('mouse:out', options)
      })
      canvas.c.on('mouse:dblclick', options => {
        canvas.c.hoverCursor = 'default'
        canvas.c.moveCursor = 'default'
        this.$emit('mouse:dblclick', options)
      })
      canvas.c.on('mouse:move', options => {
        this.$emit('mouse:move', options)

        if (this.isDraggMoving) {
          const event = options.e
          let clientX, clientY
          if (event.type === 'mousemove') {
            clientX = event.clientX
            clientY = event.clientY
          } else if (event.type === 'touchmove') {
            clientX = event.touches[0].clientX
            clientY = event.touches[0].clientY
          }
          const vpt = canvas.c.viewportTransform
          vpt[4] += clientX - this.lastPosX
          vpt[5] += clientY - this.lastPosY
          canvas.c.requestRenderAll()
          this.lastPosX = clientX
          this.lastPosY = clientY
        }
      })
      canvas.c.on('object:moving', options => {
        console.log('object:moving', options)

        this.$emit('object:moving', options)
      })
      canvas.c.on('dragover', options => {
        this.$emit('dragover', options)
      })
      canvas.c.on('selection:created', options => {
        this.$emit('selection:created', options)
      })
      canvas.c.on('before:cleared', options => {
        this.$emit('before:cleared', options)
      })
      canvas.c.on('selection:cleared', options => {
        this.$emit('selection:cleared', options)
      })
      canvas.c.on('selection:updated', options => {
        console.log('🚀 ~ canvas.c.on ~ options:', options)
        this.$emit('selection:updated', options)
      })
      canvas.c.on('after:render', options => {
        this.$emit('after:render', options)
      })
      canvas.c.on('before:selection:cleared', options => {
        this.$emit('before:selection:cleared', options)
      })
    },
    /**
     * 初始化图片加载
     */
    initImageFinish() {
      setTimeout(()=>{
      let scale = this.getInitScale()
      let zoomRatio = {
          x: 0,
          y: 0,
      }
      this.handleMouseWheel(1, scale, zoomRatio)
      const bgImage = canvas.c.backgroundImage
      const offsetX = (document_width - this.img.width * bgImage.scaleX) / 2 + 50
      const offsetY = (document_height - this.img.height * bgImage.scaleX) / 2 + 70
      canvas.c.absolutePan(new fabric.Point(-offsetX, -offsetY))
      },1000)
    },
    /**
     * 获取初始化缩放
     */
    getInitScale(){
      const document_width = this.getWindowSize().width - 60
      const document_height = this.getWindowSize().height - 130
      let scale_x = document_width / this.img.width
      let scale_y = document_height / this.img.height
      let scale = Math.min(Math.min(scale_x, scale_y), 1)
      return scale
    },
    /**
     * 单独处理鼠标滚动
     * @param e  mouse:wheel
     */
    handleMouseWheel(zoom, newZoom, zoomPoint,init=false) {
      const minZoom = CANVAS_ZOOM_NUMBER.MIN
      const maxZoom = CANVAS_ZOOM_NUMBER.MAX
      const interval = CANVAS_ZOOM_NUMBER.INTERVAL
      const clamp = value => {
        return Math.max(minZoom, Math.min(value, maxZoom))
      }
      if (newZoom > maxZoom) newZoom = maxZoom
      if (newZoom < minZoom) newZoom = minZoom

      // 地图监控模式下，最小缩放值为0.3
      if (this.isMonitor && newZoom < 0.3) newZoom = 0.3
      if (zoom == newZoom) return
      // 更新画布缩放
      const factor = newZoom / zoom
      const handleInterval = value => {
        const rounded = Math.round(value / interval) * interval
        return parseFloat(rounded.toFixed(2))
      }
      let oldLeft = 0 // 获取背景图的当前 left 和 top
      let oldTop = 0
      let newLeft = 0 // 更新后的
      let newTop = 0
      let newFactorX = 0
      let newFactorY = 0
      const zoomBackground = (factor, point) => {
        const bgImage = canvas.c.backgroundImage
        if (bgImage) {
          // 当前背景图的缩放比例
          const currentScaleX = bgImage.scaleX || 1
          const currentScaleY = bgImage.scaleY || 1

          oldLeft = bgImage.left
          oldTop = bgImage.top

          // 计算新的缩放比例
          const newScaleX = clamp(handleInterval(currentScaleX * factor))
          const newScaleY = clamp(handleInterval(currentScaleY * factor))

          newFactorX = newScaleX / currentScaleX
          newFactorY = newScaleY / currentScaleY

          const changeImage = () => {
            // 计算缩放前，鼠标相对背景图的坐标
            const relativeX = point.x - oldLeft
            const relativeY = point.y - oldTop
            // 调整背景图的 left 和 top
            newLeft = point.x - newFactorX * relativeX
            newTop = point.y - newFactorY * relativeY

            bgImage.set({
              left: newLeft,
              top: newTop,
              scaleX: newScaleX,
              scaleY: newScaleY,
            })
            bgImage.setCoords()
          }
          console.log('huhuhuhu', newScaleX, zoom, this.hasMax);
          if (newScaleX == zoom) {
            debugger
            // 缩放比例一样的话,跳过
            if (this.hasMax <= 0) {
              this.$emit('mouse:wheel', zoom, zoomPoint)
              changeImage()
            }
            this.hasMax += 1
          }
          this.hasMax = 0
          changeImage()
        }
      }
      zoomBackground(factor, zoomPoint)
      // 更新画布中其他对象的位置和尺寸
      const devicePoint = {}
      canvas.c.getObjects().forEach(function (obj) {
        // 获取背景图的缩放信息
        // 如果背景图存在，并且对象需要根据背景图缩放，处理缩放逻辑
        const bgImage = canvas.c.backgroundImage // 获取背景图
        if (bgImage) {
          // 计算背景图缩放前后变化的偏移量
          const relativeLeft = obj.left - oldLeft
          const relativeTop = obj.top - oldTop
          // 计算新的位置：考虑背景图缩放和位置变化
          let left = newLeft + relativeLeft * newFactorX
          let top = newTop + relativeTop * newFactorY
          const scaleComponent = [CANVAS_COMPONENT.DEVICE,CANVAS_COMPONENT.DEVICE_NAME,CANVAS_COMPONENT.GROUP_DEVICEGROUP_DEVICE ]
          if (scaleComponent.indexOf(obj.component)>=0) {
            // 名字偏移量要单独处理.... 1.需要先找到icon的位置,再根据icon的位置来计算name的位置 ,
            // ......................2.遍历的时候可能name先出现,icon在出现,所以需要处理顺序问题
            // 聚合点位
            if (obj.component == CANVAS_COMPONENT.GROUP_DEVICEGROUP_DEVICE) {
              const { rect, _rect } = obj
              const relativeLeft = _rect.left - oldLeft 
              const relativeTop = _rect.top - oldTop 
              left = newLeft + relativeLeft * newFactorX 
              top = newTop + relativeTop * newFactorY 
              obj.set({
                _rect:{
                  left,
                  top,
                }
              })
              // if(!init){
                left = newLeft + (relativeLeft - rect.width/2)* newFactorX 
                top = newTop + (relativeTop - rect.width/2)* newFactorY 
              // }else{
              //   left = newLeft + (relativeLeft )* newFactorX 
              //   top = newTop + (relativeTop )* newFactorY 
              // }
              
            }
            // 设备点位
            if (obj.component == CANVAS_COMPONENT.DEVICE) {
              const { id } = obj
              if (devicePoint[id]) {
                const { _obj } = devicePoint[id]
                if (_obj) {
                  const { rect, _rect } = _obj
                  let _left = left - rect.width / 2 + _rect.left
                  let _top = top + rect.height / 2 + _rect.top
                  _obj.set({
                    left: _left,
                    top: _top,
                  })
                  delete devicePoint[id]
                }
              } else {
                devicePoint[id] = {
                  _left: left,
                  _top: top,
                }
              }
            }
            // 设备名字
            if (obj.component == CANVAS_COMPONENT.DEVICE_NAME) {
              const { id } = obj
              if (devicePoint[id]) {
                const { _left, _top } = devicePoint[id]
                const { rect, _rect } = obj
                left = _left - rect.width / 2 + _rect.left - 10
                top = _top + rect.height / 2 + _rect.top - 10
                delete devicePoint[id]
              } else {
                devicePoint[id] = {
                  _obj: obj,
                }
              }
            }
            obj.set({
              scaleX: obj.scaleX,
              scaleY: obj.scaleY,
              left,
              top,
            })
          } else {
            obj.set({
              scaleX: newFactorX * obj.scaleX,
              scaleY: newFactorY * obj.scaleY, // 保持比例
              left,
              top,
            })
          }
          obj.setCoords() // 更新坐标
        }
      })
      this.$emit('mouse:wheel', canvas.c.backgroundImage.scaleX, zoomPoint)
      // 更新画布渲染
      canvas.c.renderAll()
    },

    /*
     * @param {Boolean} e
     */
    setDraging(e) {
      this.isDragging = e
    },

    initTools(type = '') {
      this.currentTool = type || ''
      canvas.c.remove(path)
      this.removePoint()
      canvas.c.defaultCursor = 'default'
    },

    createDrawLine(data) {
      this.currentTool = TOOLS.DRAWPENCIL
      this.isDragging = false
    },
    // 增加点,和路径,开始绘画
    addPoint(e) {
      const id = new Date().getTime() + Math.random() // id用来识别每个点
      // 使用吸附后的坐标，如果存在吸附点
      const pointer = this.snappedPoint || this.canvas.getPointer(e.e)
      const currentPoint = { x: pointer.x, y: pointer.y }
      let circle = new fabric.Circle({
        radius: 5,
        fill: '#1146aa',
        left: currentPoint.x,
        top: currentPoint.y,
        selectable: false,
        hasBorders: false,
        hasControls: false,
        originX: 'center',
        originY: 'center',
        id,
      })
      canvas.c.add(circle)
      // 添加到点数组
      this.pointPosition.push(currentPoint)
      // this.pointPosition.push({
      //   x: e.absolutePointer.x,
      //   y: e.absolutePointer.y,
      // })
      // this.pointPosition.length == 1 说明是第一个点
      // 这里用fabric.js里的path对象来绘制我们需要的图形对象
      // 此时往路径里面添加'M','M'的意思是开始绘画,后面的两个数字是开始点的x,y的坐标
      if (this.pointPosition.length === 1) {
        str = 'M' + currentPoint.x + ' ' + currentPoint.y
        path = new fabric.Path(str)
        path.set({
          fill: '#7c4529',
          selectable: false,
          hasBorders: false,
          hasControls: false,
          evented: false,
        })
        canvas.c.add(path)
        circle.set({
          fill: 'red',
        })
        this.pointArray.push(circle)
        // 初始化临时线条
        this.tempLine = new fabric.Line([currentPoint.x, currentPoint.y, currentPoint.x, currentPoint.y], {
          stroke: '#1a80ff',
          strokeWidth: 1.5,
          selectable: false,
          evented: false,
        })
        this.canvas.add(this.tempLine)
        this.canvas.on('mouse:move', this.drawTemporaryPath)
        this.canvas.on('mouse:move', this.drawGuideline)
      }
      // 增加第二个点时再执行下面的逻辑,这里开始绘制直线
      if (this.pointPosition.length <= 1) return
      const length = this.pointPosition.length - 1
      canvas.c.remove(path) // 先移除之前的对象
      // L在path里面就是线段的意思
      str = str + 'L' + currentPoint.x + ' ' + currentPoint.y // 路径拼接
      path = new fabric.Path(str)
      path.set({
        fill: 'rgba(255,255,255,0.1)',
        opacity: 0.5,
        strokeWidth: 1.5,
        stroke: '#1a80ff',
        selectable: true,
        hasBorders: false,
        hasControls: false,
        evented: false,
      })
      canvas.c.add(path) // 重新添加
      canvas.c.renderAll()
      this.pointArray.push(circle)

      // 移除之前的动态线条
      if (this.tempLine) {
        this.canvas.remove(this.tempLine)
        this.tempLine = null
      }

      // 准备新动态线段
      this.tempLine = new fabric.Line([currentPoint.x, currentPoint.y, currentPoint.x, currentPoint.y], {
        stroke: '#1a80ff',
        strokeWidth: 1.5,
        selectable: false,
        evented: false,
      })
      canvas.c.add(this.tempLine)
    },

    drawGuideline(e) {
      if (!this.guideline) {
        this.guideline = new fabric.Line([0, 0, 0, 0], {
          stroke: '#ff0000',
          strokeDashArray: [5, 5],
          selectable: false,
          evented: false,
        })
        this.canvas.add(this.guideline)
      }

      const pointer = this.canvas.getPointer(e.e)
      let snappedX = null
      let snappedX_Y = null
      let snappedY = null
      let snappedY_X = null

      // 遍历所有已有点，判断是否接近水平或垂直位置
      for (let i = 0; i < this.pointPosition.length; i++) {
        const point = this.pointPosition[i]

        if (Math.abs(pointer.x - point.x) < 10) {
          snappedX = point.x // 吸附到垂直线
          snappedX_Y = point.y
        }
        if (Math.abs(pointer.y - point.y) < 10) {
          snappedY = point.y // 吸附到水平线
          snappedY_X = point.x
        }
      }

      // 显示辅助线
      if (snappedX !== null) {
        this.guideline.set({
          x1: snappedX,
          y1: snappedX_Y,
          x2: snappedX,
          y2: pointer.y,
          visible: true,
        })
      } else if (snappedY !== null) {
        this.guideline.set({
          x1: snappedY_X,
          y1: snappedY,
          x2: pointer.x,
          y2: snappedY,
          visible: true,
        })
      } else {
        // 隐藏辅助线
        this.guideline.set({ visible: false })
      }

      // 设置吸附坐标
      if (snappedX !== null || snappedY !== null) {
        this.snappedPoint = {
          x: snappedX !== null ? snappedX : pointer.x,
          y: snappedY !== null ? snappedY : pointer.y,
        }
      }

      this.canvas.renderAll()
    },

    removeGuideline() {
      if (this.guideline) {
        this.canvas.off('mouse:move', this.drawGuideline)
        this.canvas.remove(this.guideline)
        this.guideline = null
      }
    },

    drawTemporaryPath(e) {
      const pointer = this.canvas.getPointer(e.e)
      const lastPoint = this.pointPosition[this.pointPosition.length - 1]

      if (!lastPoint) return

      // 吸附阈值
      const snapThreshold = 10

      // 计算坐标差
      const dx = Math.abs(pointer.x - lastPoint.x)
      const dy = Math.abs(pointer.y - lastPoint.y)

      let adjustedX = pointer.x
      let adjustedY = pointer.y

      // 吸附逻辑
      if (dx < snapThreshold) {
        adjustedX = lastPoint.x // 吸附到垂直方向
      }
      if (dy < snapThreshold) {
        adjustedY = lastPoint.y // 吸附到水平方向
      }

      // 更新动态线条的终点
      this.tempLine.set({
        x2: adjustedX,
        y2: adjustedY,
      })

      // 保存吸附点，用于点击事件
      this.snappedPoint = { x: adjustedX, y: adjustedY }

      this.canvas.requestRenderAll()
    },

    finishDrawing(e) {
      /* 打开拖拽 */
      // this.$emit('toolSelect', true)
      // 获取所在图片
      canvas.c.remove(path)
      // 最后一个点的坐标就是第一个点的坐标
      this.pointPosition.push({
        x: this.pointPosition[0].x,
        y: this.pointPosition[0].y,
      })
      // 给路径加'z','z'说明整个path路径已经完结
      str = str + 'z'

      const pathData = []
      this.pointPosition.forEach((point, index) => {
        const cmd = index === 0 ? 'M' : 'L' // 第一个点使用'M'命令，其他点使用'L'命令
        pathData.push([cmd, point.x, point.y])
      })
      pathData.push('z') // 闭合路径

      let Rect = {
        // gpNo: 0,
        // areaName: '',
        // id: this.uuid(),
        // imageNo: this.$parent.$parent.nowImageNo,
        pathData: str,
        // visibleRectTxt:this.$store.state.visual.visibleRectTxt
      }
      Rect.path = pathData
      this.$emit('drawRectBack', Rect)
      this.isDragging = true
      this.currentTool = ''
    },
    // 移除pencil点
    removePoint() {
      for (const item of this.pointArray) {
        canvas.c.remove(item)
      }
      str = ''
      if (this.tempLine) {
        canvas.c.remove(this.tempLine)
      }
      this.removeGuideline()
      this.snappedPoint = null
      this.pointArray = []
      this.pointPosition = []
      // path.set({
      //   stroke: null
      // })
      canvas.c.renderAll()
    },
    rectCallBack() {},

    createDrawRect(data) {
      this.currentTool = TOOLS.DRAWRECT
      this.isDragging = false
      canvas.c.defaultCursor = 'crosshair'
    },
    doDrawRect() {
      if (JSON.stringify(downPoint) === JSON.stringify(upPoint)) {
        return
      }
      /* 打开拖拽 */
      // this.$emit('toolSelect', true)
      const top = Math.min(downPoint.y, upPoint.y)
      const left = Math.min(downPoint.x, upPoint.x)
      const width = Math.abs(downPoint.x - upPoint.x)
      const height = Math.abs(downPoint.y - upPoint.y)

      // 遍历绘制路径的四个边
      const points = [
        { x: left + width, y: top }, // 右上角
        { x: left + width, y: top + height }, // 右下角
        { x: left, y: top + height }, // 左下角
        { x: left, y: top }, // 左上角（闭合路径）
      ]

      let str = `M${left} ${top}` // 移动到起始点

      points.forEach(point => {
        str += `L${point.x} ${point.y}` // 添加直线段
      })

      str += 'z' // 闭合路径

      const pathData = []
      points.forEach((point, index) => {
        const cmd = index === 0 ? 'M' : 'L' // 第一个点使用'M'命令，其他点使用'L'命令
        pathData.push([cmd, point.x, point.y])
      })
      pathData.push('z') // 闭合路径

      let Rect = {
        // gpNo: 0,
        // areaName: '',
        // id: this.uuid(),
        // imageNo: this.$parent.$parent.nowImageNo,
        pathData: str,
        // visibleRectTxt:this.$store.state.visual.visibleRectTxt
      }
      Rect.path = pathData
      this.$emit('drawRectBack', Rect)
      downPoint = null
      upPoint = null
      this.isDragging = true
      this.currentTool = ''
    },
    removeMouseFun() {
      canvas.c.off('mouse:down')
      canvas.c.off('mouse:up')
      canvas.c.off('drop')
      canvas.c.off('dragenter')
      canvas.c.off('mouse:over')
      canvas.c.off('mouse:out')
      canvas.c.off('mouse:move')
      canvas.c.off('mouse:moving')
      canvas.c.off('selection:created')
    },
    getWindowSize() {
      let width = document.documentElement.clientWidth
      let height = document.documentElement.clientHeight

      try {
        // 传递容器, 以容器尺寸为准
        if (this.mapContainerSelector) {
          /** @type {HTMLDivElement} */
          const container = document.querySelector(this.mapContainerSelector)
          width = container.offsetWidth || width
          height = container.offsetHeight || height
        }
      } catch (error) {}

      return {
        width,
        height,
      }
    },
    /**
     * @param {fabric.Object} obj
     * @param {String} img Equipment image
     */
    changeEquImage(obj, img) {
      if (obj.component === 'Equipment') {
        const equObject = obj.getObjects()
        const _img = equObject.find(i => {
          return i.isType('image')
        })

        // 有缓存需要删除
        // obj.removeWithUpdate(_img)

        _img.setSrc(img, () => {
          // obj.addWithUpdate(_img)
          canvas.c.requestRenderAll()
          canvas.c.renderAll()
        })
      }
    },
    /**
     * @param {fabric.Object} obj
     * @param {String} name  键
     * @param {String||Number} value 值
     */
    changeEquObject(obj, name, value) {
      if (obj.component === 'Equipment') {
        const equObject = obj.getObjects().find(i => {
          return i.component === 'circle'
        })
        equObject.set(name, value)
      }
      canvas.c.requestRenderAll()
    },
    /**
     * @param {fabric.Object} obj
     * @param {String} name  键
     * @param {String||Number} value 值 */
    changeEquName(obj, name, value) {
      const equNameObject = this.$parent.EquipmentNameData.find(item => item.id === obj.id)
      const equName = equNameObject.getObjects().find(i => {
        return i.type === 'i-text'
      })
      // let rectWidth = deviceTitle.width + 20
      const equNameRect = equNameObject.getObjects().find(i => {
        return i.type === 'rect'
      })
      equName.set('text', value)
      equNameRect.set('width', equName.width + 20)
      // 更新设备对象的 deviceName
      debugger
      const deviceObject = canvas.c.getObjects().find(item => item.id === obj.id && item.component === 'Equipment')
      if (deviceObject) {
        deviceObject.set('deviceName', value)
      }
      canvas.c.requestRenderAll()
    },
    /**
     * @param {fabric.Object} obj
     * @param {String||Number} value
     */
    changeRoomName(obj, value = '') {
      if (obj.component === 'Rect') {
        const roomObject = canvas.c.getObjects()
        const _thisRoomName = roomObject.filter(item => {
          return item.id === obj.id && item.component === 'RoomName'
        })
        _thisRoomName[0].set('text', value)
        _thisRoomName[0].set({
          gpNo: obj.gpNo,
          // left: obj.left,
          // top: obj.top,
        })

        canvas.c.renderAll()
      }
    },

    createTips(obj, name) {
      const tipsText = new fabric.Text(name, {
        textAlign: 'center',
        fontSize: 12,
        fill: '#000',
        backgroundColor: '#fff',
        originX: 'center',
        originY: 'center',
      })

      const radiusRect1 = new fabric.Rect({
        fill: '#fff',
        width: tipsText.width + 20,
        height: 24,
        rx: 12, // 圆角大小
        ry: 12,
        originX: 'center',
        originY: 'center',
        shadow: '5px 5px 6px rgba(0, 0, 0, 0.4)',
      })

      const MkNameGroup = (...args) => {
        const group = new fabric.Group(args)
        group.moveTo(3)
        return group.set({
          component: 'TipName',
          cornerSize: 3,
          centeredScaling: true,
          hasBorders: false,
          hasControls: true,
          objectCaching: false,
          top: obj.top - radiusRect1.height / 2 - 35,
          left: obj.left - radiusRect1.width / 2 + 20,
          visible: obj.visible, // 初始可见性
          selectable: false,
          lockMovementX: true,
          lockMovementY: true,
        })
      }

      // 创建并添加到画布
      const tipsGroup = MkNameGroup(radiusRect1, tipsText)
      canvas.c.add(tipsGroup)
      canvas.c.renderAll()

      return tipsGroup // 返回 group 以便外部控制
    },

    createDeviceName(obj, name) {
      /* 设备名称文字 */
      const deviceTitle = new fabric.Text(obj.deviceName, {
        textAlign: 'center',
        fontSize: 12,
        fill: '#000',
        backgroundColor: '#fff',
        originX: 'center',
        originY: 'center',
      })

      let rectWidth = deviceTitle.width + 20
      /* 设备名称矩形 */
      const radiusRect1 = new fabric.Rect({
        fill: '#fff',
        width: rectWidth,
        height: 24,
        rx: 12, // 圆角大小
        ry: 12,
        originX: 'center',
        originY: 'center',
        // stroke: '#000', // 边框颜色
        // strokeWidth: 1, // 边框粗细
        shadow: '5px 5px 6px rgba(0, 0, 0, 0.4)',
      })

      // let deviceName = ''
      // if (obj.deviceName) {
      //   if (obj.deviceName.split('').length > 8) {
      //     deviceName = obj.deviceName.split('').splice(0, 8)
      //     let txt = ''
      //     for (let i = 0; i < deviceName.length; i++) {
      //       txt += deviceName[i]
      //     }
      //     deviceName = txt + '...'
      //   } else {
      //     deviceName = obj.deviceName
      //   }
      // }

      // deviceTitle.set({
      //   top: radiusRect1.getCenterPoint().y - deviceTitle.height / 2,
      //   left: radiusRect1.getCenterPoint().x - deviceTitle.width / 2
      // })

      const MkNameGroup = (...args) => {
        const group = new fabric.Group(args)
        group.moveTo(3)
        return group.set({
          component: 'EquipmentName',
          cornerSize: 3,
          centeredScaling: true,
          hasBorders: false,
          hasControls: false,
          objectCaching: false,
          top: obj.top + radiusRect1.height / 2 + 35,
          left: obj.left - radiusRect1.width / 2 + 20,
          visible: obj.visibleTitle || false,
          selectable: false,
          lockMovementX: true,
          lockMovementY: true,
          id: obj.id,
          gpNo: obj.gpNo,
          areaName: obj.areaName,
        })
      }

      canvas.c.add(MkNameGroup(radiusRect1, deviceTitle))
      canvas.c.renderAll()
    },

    /**
     * @param {Object} options
     */

    async createDevice(options = {}, sensorValue = '') {
      return new Promise((resolve, reject) => {
        //传感器状态
        const SENSORTYPE = {
          offline: '2',
          online: '1',
        }

        // 传感器类别
        const SENSORCHILDCATEGORYTYPE = 128

        /* 设备边框 */
        // 在线: #EDF5FF, 离线/关闭: #E0E6EE, 告警: #E42828, 故障: #FEB202, 虚拟设备: #1D6BC1
        // let fill = options.isVirtual ? options.statusType?'#775E37':'#EDF5FF' : '#1D6BC1'
        const { fill, isSensor, sensorValue } = options
        // console.log('isAlarm, isError: ', isAlarm, isError);
        // if(deviceStatusColor){ fill = deviceStatusColor}
        // if(isAlarm) { fill = '#E42828' } // 告警设备的填充颜色
        // if(isError) { fill = '#FEB202' } // 故障设备的填充颜色

        const circle = new fabric.Circle({
          radius: 20, // 圆的半径
          fill,
          component: 'circle',
          transparentCorners: false,
          strokeWidth: 3,
          lockScalingX: true, // 禁止水平缩放
          lockScalingY: true, // 禁止垂直缩放
        })

        /* 设备名称文字 */
        const deviceTitle = new fabric.IText(options.deviceName, {
          textAlign: 'center',
          fontSize: 12,
          fill: '#000',
          backgroundColor: '#fff',
          originX: 'center',
          originY: 'center',
          editable: true,
          selectable: false, // 设置为 false，禁止选择
          hasBorders: false, // 不显示边框
          hasControls: false, // 不显示控制点
          lockMovementX: true, // 锁定水平移动
          lockMovementY: true, // 锁定垂直移动
        })

        //添加双击事件进入编辑模式
        // deviceTitle.on('mousedblclick', () => {
        //     deviceTitle.enterEditing();
            
        //     // 先让光标定位到文本末尾
        //     deviceTitle.selectionStart = deviceTitle.text.length;
        //     deviceTitle.selectionEnd = deviceTitle.text.length;

        //     setTimeout(() => {
        //       if (deviceTitle.hiddenTextarea) {
        //         deviceTitle.hiddenTextarea.focus();
        //         deviceTitle.hiddenTextarea.setSelectionRange(deviceTitle.text.length, deviceTitle.text.length);
        //       }
        //       canvas.c.requestRenderAll();
        //     }, 0);
        //   });


        deviceTitle.on('editing:entered', () => {
          setTimeout(() => {
            if (deviceTitle.hiddenTextarea) {
              // 处理回车键事件
              const handleNameChange = value => {
                this.$emit('isReNameEdit', false)
                // 防止重复触发
                // if (deviceTitle.isProcessingChange) return
                // deviceTitle.isProcessingChange = true

                // 找到对应的设备对象并更新 deviceName
                const deviceObject = canvas.c.getObjects().find(item => 
                    item.id === options.id && 
                    item.component === 'Equipment'
                  )
                  if (deviceObject) {
                    deviceObject.set('deviceName', value)
                  }

                // 获取设备名称组
                const nameGroup = canvas.c.getObjects().find(obj => obj.component === 'EquipmentName' && obj.id === options.id)
                if (nameGroup) {
                  // 更新文本内容
                  const text = nameGroup.getObjects().find(obj => obj.type === 'i-text')
                  const rect = nameGroup.getObjects().find(obj => obj.type === 'rect')
                  if (text && rect) {
                    // 更新文本和矩形宽度
                    text.set('text', value)
                    rect.set('width', text.width + 20)
                  }
                }

                eventBus.$emit('changeDeviceName', options, value)

                canvas.c.requestRenderAll()

                // // 重置状态
                // setTimeout(() => {
                //   deviceTitle.isProcessingChange = false
                // }, 1000)
              }

              // 移除可能存在的旧事件监听器
              if (deviceTitle.keydownHandler) {
                deviceTitle.hiddenTextarea.removeEventListener('keydown', deviceTitle.keydownHandler)
              }
              if (deviceTitle.blurHandler) {
                deviceTitle.hiddenTextarea.removeEventListener('blur', deviceTitle.blurHandler)
              }

              // 保存新的事件处理函数引用
              deviceTitle.keydownHandler = e => {
                if (e.keyCode === 13) {
                  // 监听回车键
                  e.preventDefault()
                   // 主动触发失焦事件
                  deviceTitle.hiddenTextarea.blur()
                  // handleNameChange(e.target.value)
                }
              }

              deviceTitle.blurHandler = e => {
                console.log('shijiao ', 1);
                deviceTitle.exitEditing()
                setTimeout(() => {
                  console.log('shijiao ', 2);
                  const time = Math.abs(new Date().getTime() - this.$store.state.escTime)
                    if(time < 1000) return 
                    // 如果不是因为回车键触发的失焦，才处理失焦事件
                   
                    handleNameChange(e.target.value)
                    
                 }, 500)
              }

              // 添加新的事件监听器
              deviceTitle.hiddenTextarea.addEventListener('keydown', deviceTitle.keydownHandler)
              deviceTitle.hiddenTextarea.addEventListener('blur', deviceTitle.blurHandler)
              // 监听画布缩放事件
              const handleZoom = () => {
                if (deviceTitle.isEditing) {
                  deviceTitle.hiddenTextarea.removeEventListener('blur', deviceTitle.blurHandler);
                  deviceTitle.exitEditing();
                  // 重新添加 blur 事件监听器
                  setTimeout(() => {
                    deviceTitle.hiddenTextarea.addEventListener('blur', deviceTitle.blurHandler);
                  }, 100);
                }
              }
              canvas.c.on('mouse:wheel', handleZoom)
            }
          }, 100)
        })

        let rectWidth = deviceTitle.width + 20

        /* 设备名称矩形 */
        const radiusRect1 = new fabric.Rect({
          fill: '#fff',
          width: rectWidth,
          height: 24,
          rx: 12, // 圆角大小
          ry: 12,
          originX: 'center',
          originY: 'center',
          shadow: '5px 5px 6px rgba(0, 0, 0, 0.4)',
        })

        let sensorCircle, waveCircle, waveCircle1, waveCircle2
        if (options?.propValue?.ChildCategoryType === 128) {
          circle.fill = 'rgba(255,255,255,0)'
        }

        if (isSensor) {
          sensorCircle = new fabric.Circle({
            radius: 12, // 圆的半径
            fill: '#fff',
            component: 'circle',
            left: circle.getCenterPoint().x,
            top: circle.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })

          if (sensorValue !== null) {
            circle.fill = 'rgba(255,255,255,0)'
          }

          const fill =
            sensorValue === null ? 'rgba(0,0,0,0)' : sensorValue === SENSORTYPE.HASPERSON ? 'rgba(94, 215, 255, 0.3)' : 'rgba(130, 130, 130, 0.3)'
          const fill1 =
            sensorValue === null ? 'rgba(0,0,0,0)' : sensorValue === SENSORTYPE.HASPERSON ? 'rgba(94, 215, 255, 0.2)' : 'rgba(130, 130, 130, 0.2)'
        }

        if (sensorValue !== '2' && sensorValue !== '--') {
          waveCircle = new fabric.Circle({
            component: 'wave',
            radius: 14, // 圆的半径
            fill: sensorValue === '1' ? 'rgba(94, 215, 255, 0.3)' : 'rgba(130, 130, 130, 0.3)',
            left: circle.getCenterPoint().x,
            top: circle.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })

          waveCircle1 = new fabric.Circle({
            component: 'wave1',
            radius: 18, // 圆的半径
            fill: sensorValue === '1' ? 'rgba(94, 215, 255, 0.2)' : 'rgba(130, 130, 130, 0.2)',
            left: circle.getCenterPoint().x,
            top: circle.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })

          waveCircle2 = new fabric.Circle({
            component: 'wave2',
            radius: 22, // 圆的半径
            fill: sensorValue === '1' ? 'rgba(94, 215, 255, 0.2)' : 'rgba(130, 130, 130, 0.2)',
            left: circle.getCenterPoint().x,
            top: circle.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })
        }

        if (sensorValue === '2') {
          waveCircle = new fabric.Circle({
            component: 'wave',
            radius: 14, // 圆的半径
            fill: 'rgba(0,0,0,0)',
            left: circle.getCenterPoint().x,
            top: circle.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })

          waveCircle1 = new fabric.Circle({
            component: 'wave1',
            radius: 18, // 圆的半径
            fill: fill1,
            left: circle.getCenterPoint().x,
            top: circle.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })

          waveCircle2 = new fabric.Circle({
            component: 'wave2',
            radius: 22, // 圆的半径
            fill: fill1,
            left: circle.getCenterPoint().x,
            top: circle.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })
        }

        /*
         * 获取圆心 const circleCenter = circle.center()
         */

        new fabric.Image.fromURL(macBg, img => {
          //有mac的设备背景图
          const macBgImage = img
            .set({
              component: 'circle',
              left: circle.getCenterPoint().x - (img.width * 0.4) / 2,
              top: circle.getCenterPoint().y - (img.height * 0.4) / 2,
            })
            .scale(0.4)

          /* 设备图片 */
          const data = new fabric.Image.fromURL(options.iconUrl, img => {
            const img1 = img
              .set({
                left: circle.getCenterPoint().x - (img.width * 0.3) / 2,
                top: circle.getCenterPoint().y - (img.height * 0.3) / 2,
              })
              .scale(0.29)

            let _thisGroup
            const MkGroup = (...args) => {
              const group = new fabric.Group(args)
              group.moveTo(3)
              group.set({
                cornerSize: 3,
                centeredScaling: true,
                hasBorders: false,
                hasControls: false,
                objectCaching: false,
                isSelected: false,
                lockMovementX: true,
                lockMovementY: true,
                ...options,
              })
              group.set({
                left: options.left - group.width / 2,
                top: options.top - group.height / 2,
              })
              _thisGroup = group
              return group
            }

            const MkNameGroup = (...args) => {
              const group = new fabric.Group(args)
              group.moveTo(3)
              const _top = sensorValue !== '' ? 48 : 35
              const _left = sensorValue !== '' ? 30 : 20
              // group.moveTo(999)
              return group.set({
                component: 'EquipmentName',
                cornerSize: 3,
                centeredScaling: true,
                hasBorders: false,
                hasControls: false,
                objectCaching: false,
                top: _thisGroup.top + radiusRect1.height / 2 + _top - 10,
                left: _thisGroup.left - radiusRect1.width / 2 + _left - 10,
                visible: options.visibleTitle || false,
                selectable: false,
                lockMovementX: true,
                lockMovementY: true,
                subTargetCheck: true, // 允许选择组内对象
                evented: true,
                id: options.id,
                gpNo: options.gpNo,
                areaName: options.areaName,
                rect: {
                  width: radiusRect1.width,
                  height: radiusRect1.height,
                },
                _rect: {
                  top: _top,
                  left: _left,
                },
              })
            }

            let DrawGroup

            if (options.isVirtual) {
              if (isSensor) {
                DrawGroup = MkGroup(waveCircle2, waveCircle1, waveCircle, circle, sensorCircle, img1)
              } else {
                DrawGroup = MkGroup(circle, img1)
              }
            } else if (options.visibleMac) {
              DrawGroup = MkGroup(macBgImage, img1)
            } else {
              DrawGroup = MkGroup(circle, img1)
            }
            const name = MkNameGroup(radiusRect1, deviceTitle)
            // 判断是否进来的时候
            if (options.hasRadius) {
              DrawGroup.set({ visible: false })
              name.set({ visible: false })
            }
            canvas.c.add(DrawGroup)
            canvas.c.add(name)
            canvas.c.renderAll()
            resolve() // 通知单个设备的渲染完成
          })
        })
      })
    },

    /**
     * 聚合点位
     * @param options
     * @param number
     */
    createGroupDevice(options, number, forceRect = {}) {
      try {
          /* 设备数量 */
          let center = 20
          const left = options.left 
          const top = options.top 
          const radiusRect = new fabric.Circle({
            radius: 20, // 圆的半径
            id: options.id,
            gpNo: options.id,
            pointNumber: number,
            ...forceRect,

          })
          const color  = options.status == GROUP_STATUS.ALARM ? '#C82B2A':options.status == GROUP_STATUS.FAULT ? '#FFAC1C':'#5A9CF8'
          radiusRect.set('fill', new fabric.Gradient({
            type: 'radial',
            gradientUnits: 'pixels', // 使用像素单位
            coords: {
               x1: center,  // 内部圆心X
               y1: center,  // 内部圆心Y
               r1: 0,              // 内部半径
               x2: center,  // 外部圆心X
               y2: center,  // 外部圆心Y
               r2: center,  // 外部半径（整个圆）
            },
            colorStops: [
              { offset: 0.44, color: 'rgba(216, 216, 216, 0)' }, // 44% 透明
              { offset: 0.98, color: color }, // 98% 深红色
            ],
         }));
          const number_str = number + ''
          const deviceTitle = new fabric.Text(number_str, {
            textAlign: 'center',
            fontSize: 12,
            originX: 'center',
            originY: 'center',
            fill: '#fff',
            left: radiusRect.getCenterPoint().x,
            top: radiusRect.getCenterPoint().y,
          })
          let rectWidth1 = 30
          /* 设备数量矩形 */
          const radiusRect1 = new fabric.Circle({
            radius: 15, // 圆的半径
            left: radiusRect.getCenterPoint().x,
            top: radiusRect.getCenterPoint().y,
            originX: 'center',
            originY: 'center',
          })
          // 计算 129° 方向的坐标
          const angle1 = 129 * (Math.PI / 180); // 转换为弧度
          const x2_1 = rectWidth1 * Math.cos(angle1);
          const y2_1 = rectWidth1 * Math.sin(angle1); 
          radiusRect1.set('fill', new fabric.Gradient({
            type: 'linear',  // 放射性渐变
            gradientUnits: 'pixels',
            coords: { x1: 0, y1: 0, x2:x2_1, y2:y2_1 }, // 129° 方向
            colorStops: [
            { offset: 0.14, color: '#0150C7' }, // 14% 位置，深蓝色
            { offset: 0.85, color: '#5A9CF8' }, // 85% 位置，浅蓝色
            ],
         }));
          const MkNameGroup = (...args) => {
            const group = new fabric.Group(args)
            group.moveTo(1)
            return group.set({
              component: CANVAS_COMPONENT.GROUP_DEVICEGROUP_DEVICE,
              cornerSize: 3,
              centeredScaling: true,
              hasBorders: false,
              hasControls: false,
              objectCaching: false,
              selectable: false,
              lockMovementX: true,
              lockMovementY: true,
              id: options.gpNo,
              gpNo: options.gpNo,
              left:left-center,
              top:top-center,
              rect: {
                width: center *2,
                height: center *2,
              },
              _rect:{
                left,
                top,
              },
              pointNumber: number,
              ...forceRect
            })
          }
          const name = MkNameGroup(radiusRect,radiusRect1, deviceTitle)
          // 判断是否进来的时候
          if (!options.hasRadius) {
            name.set({ visible: false })
          }
          canvas.c.add(name)
          canvas.c.requestRenderAll()
      } catch (error) {
        console.warn('.....error', error)
      }
    },
    /**
     * @param {Object} options
     * @param {Number} number
     */
    createNumbers(options, number) {
      const text = new fabric.Text(number)
      text.set({
        textAlign: 'center',
        fontSize: 200,
        fill: '#000',
        component: 'roomNumber',
        // left: point.x,
        // top: point.y,
        fontWeight: 'bold',
        fontFamily: 'PingFang SC',
        stroke: '#fff', // 描边
        strokeWidth: 6,
        selectable: false,
        lockMovementX: true,
        lockMovementY: true,
        left: options.left + options.width / 2 - text.width * 2,
        top: options.top + options.height / 2 - text.height * 2,
      })
      canvas.c.add(text)
      canvas.c.requestRenderAll()
    },

    /**
     * @param {Object} options
     * @param {String} name
     * @param {Boolean} select
     */
    createRooms(options, name = '', select = false) {
      fabric.Object.prototype.transparentCorners = false
      fabric.Object.prototype.cornerColor = 'red'
      fabric.Object.prototype.cornerStyle = 'circle'
      const path = new fabric.Path(options.pathData)
      const irregularPoints = convertPoints(path.path)
      const isRectangle = isSpecialRectangle(irregularPoints)
      path.set({
        ...options,
        fill: 'rgba(255,255,255,0.1)',
        stroke: '#A1A1A1',
        strokeWidth: 6,
        component: 'Rect',
        // 图形空白处无法选中图形
        perPixelTargetFind: true,
        objectCaching: false,
        lockMovementX: true,
        lockMovementY: true,
        hasControls: false,
        // selectable: false
        isSelected: false,
        isRectangle: isRectangle,
      })
      path.moveTo(4)
      const _text = options.gpNo ? options.areaName : name

      // 房间名称
      const txt = new fabric.Text(_text, {
        ...options,
        fill: '#666',
        // shadow: '0px 1px 2px rgba(255,255, 255, 1)',
        component: 'RoomName',
        id: options.id,
        fontSize: 18,
        // 添加文字描边
        // stroke: '#edf1f9',     // 描边颜色（白色）
        // strokeWidth: 0.8 ,    // 描边宽度
        // strokeLineJoin:'round', // 描边圆边
        // left: point.x,
        // top: point.y,
        fontWeight: 'bold',
        // fontFamily: '苹方-简',
        // stroke: '#fff', // 描边
        // strokeWidth: 1.5,
        // backgroundColor: '#fff',
        selectable: true,
        lockMovementX: false,
        lockMovementY: false,
        hasControls: true,
        visible: options.visibleRectTxt,
      })

      //path 选中
      path.on('selected', e => {
        canvas.c.setActiveObject(path)
        console.log('path selected', e)
      })

      const { x, y } = processAndFindBestEdge(path.path, path)

      txt.set({
        left: x + 12,
        top: y + 12,
      })

      txt.moveTo(3)
      canvas.c.add(path)
      canvas.c.add(txt)
      //canvas.setActiveObject(path);
      canvas.c.sendToBack(txt)
      canvas.c.sendToBack(path)

      if (select) {
        canvas.c.setActiveObject(path)
      }
      canvas.c.requestRenderAll()

      this.initialRoomNameOffsetFun()
    },

    changeEnterIsShow(activeObject, e) {
      console.log('activeObject', activeObject)
      if (e[0].level === 2 || e[0].level === 3) {
        this.enterGroup.set({ visible: true, gpNo: activeObject.gpNo, areaName: activeObject.areaName, level: activeObject.level })
        this.initialVisibility = true
        canvas.c.renderAll() // 重新渲染画布
      }
    },

    /**
     * @param {String} imgPath   修改背景图片
     * @param {Number} width  选传
     * @param {Number} height 选传
     * @param {Number} 0~1 opacity 必传
     */
    changeCanvasBg(options) {
      const { url, width, height, opacity, visible } = options
      fabric.Image.fromURL(
        url, // 真实图片地址
        img => {
          this.img = img;
          const document_width = this.getWindowSize().width - 60
          const document_height = this.getWindowSize().height - 130
          let scale_x = document_width / img.width
          let scale_y = document_height / img.height
          let scale = Math.min(Math.min(scale_x, scale_y), 1)
          this.firstImgScale = scale

          if (!this.$store.state.mapGroup) {
            // 将图片设置再画布上，然后重新渲染画布，图片就出来了。
            canvas.c.setBackgroundImage(img, canvas.c.renderAll.bind(canvas.c), {
              scaleX: 1,
              scaleY: 1,
              originX: 'left',
              originY: 'top',
              opacity: typeof opacity === 'number' ? opacity : 1,
              visible: visible !== false,
            })
            canvas.c.setZoom(scale)
            const offsetX = (document_width - img.width * scale) / 2 + 50
            const offsetY = (document_height - img.height * scale) / 2 + 70
            console.log('offsetX', offsetX, this.getWindowSize().height)
            canvas.c.absolutePan(new fabric.Point(-offsetX, -offsetY))
          } else {
            // 将图片设置再画布上，然后重新渲染画布，图片就出来了。
            canvas.c.setBackgroundImage(img, canvas.c.renderAll.bind(canvas.c), {
              scaleX: 1,
              scaleY: 1,
              originX: 'left',
              originY: 'top',
              opacity: typeof opacity === 'number' ? opacity : 1,
              visible: visible !== false,
            })
          }
          this.$emit('changeImgPathFinish')
          
        }
      )
    },

    /**
     * @param {Array} array  画布元素
     */
    selectedObjects(array) {
      canvas.c.discardActiveObject()
      const sel = new fabric.ActiveSelection(array, {
        canvas: canvas.c,
      })

      canvas.c.setActiveObject(sel)
      canvas.c.requestRenderAll()
      canvas.c.renderAll()
    },

    /**
     * @return {Object} currState  全部画布数据
     */
    saveCanvas() {
      const importData = [
        'id',
        'isSelected',
        'areaName',
        'gpNo',
        'propValue',
        'isVirtual',
        'component',
        'centeredScaling',
        'cornerSize',
        'perPixelTargetFind',
        'hasBorders',
        'hasControls',
      ]
      // 导出当前画布信息
      const currState = canvas.c.toJSON(importData)
      return currState
    },
  },
}
</script>

<style lang="scss" scoped>
.MainViewPort {
  position: relative;
}
</style>
